var $3huVH$loadscript2 = require("load-script2");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "init", function () { return $a196c1ed25598f0e$export$2cd8252107eb640b; });
$parcel$export(module.exports, "default", function () { return $a196c1ed25598f0e$export$2e2bcd8739ae039; });

var $a196c1ed25598f0e$var$TRUV_BRIDGE_URL = 'https://cdn.citadelid.com/bridge.js';
var $a196c1ed25598f0e$var$Bridge;
var $a196c1ed25598f0e$var$scriptLoadingPromise = null;
var $a196c1ed25598f0e$var$bridgeProxyFactory = function(bridgeConfig) {
    if (!$a196c1ed25598f0e$var$scriptLoadingPromise) $a196c1ed25598f0e$var$scriptLoadingPromise = $a196c1ed25598f0e$var$loadTruvScript();
    var bridgeInstance = null;
    var needOpen = false;
    var initializeStarted = false;
    var initBridgeInstance = function() {
        if (initializeStarted || $a196c1ed25598f0e$var$scriptLoadingPromise === null) return Promise.resolve();
        initializeStarted = true;
        return $a196c1ed25598f0e$var$scriptLoadingPromise.then(function() {
            if (!$a196c1ed25598f0e$var$Bridge) {
                console.error('Error opening Truv Bridge');
                return;
            }
            if (needOpen) {
                bridgeInstance = $a196c1ed25598f0e$var$Bridge.init(bridgeConfig);
                bridgeInstance.open();
            }
        });
    };
    return {
        open: function() {
            if (bridgeInstance) bridgeInstance.open();
            else {
                needOpen = true;
                initBridgeInstance();
            }
        },
        close: function() {
            if (bridgeInstance) bridgeInstance.close();
            else needOpen = false;
        }
    };
};
var $a196c1ed25598f0e$var$loadTruvScript = function() {
    return ($parcel$interopDefault($3huVH$loadscript2))($a196c1ed25598f0e$var$TRUV_BRIDGE_URL).then(function() {
        var windowWithBridge = window;
        if (!windowWithBridge.TruvBridge) {
            console.error('Error loading Truv Bridge');
            return;
        }
        $a196c1ed25598f0e$var$Bridge = windowWithBridge.TruvBridge;
    }).catch(function(error) {
        console.error('Error loading Truv Bridge', error);
    });
};
var $a196c1ed25598f0e$export$2cd8252107eb640b = function(bridgeConfig) {
    if ($a196c1ed25598f0e$var$Bridge) return $a196c1ed25598f0e$var$Bridge.init(bridgeConfig);
    return $a196c1ed25598f0e$var$bridgeProxyFactory(bridgeConfig);
};
var $a196c1ed25598f0e$export$2e2bcd8739ae039 = {
    init: $a196c1ed25598f0e$export$2cd8252107eb640b
};


//# sourceMappingURL=index.js.map
